import { Trans, useLingui } from "@lingui/react";
import { TradeOrgPages } from "src/types/tradeorgPages.ts";
import List from "./components/List.tsx";
import OrgLinks from "./components/OrgLinks.tsx";
import Text from "./components/Text.tsx";
import Title from "./components/Title.tsx";
import { Layout } from "./Layout.tsx";

const MobilityPool = () => {
  const { i18n } = useLingui();
  const pageName = TradeOrgPages.MobilityPool;

  const pageTitle = i18n._({
    id: "tradeOrgLayout.page.title",
    message: "Advantages with {tradeOrgName}",
    comment: "Page title with trade organization name",
    values: { tradeOrgName: "Mobility Pool" },
  });

  const descriptionText = i18n._({
    id: "tradeOrgLayout.mobilitypool.description.text",
    message:
      "Our members have expertise, agreements and tools that make your car purchase easier and safer.\n" +
      "Mobility Pool AS is a purchasing group of over 1,150 used car dealers.",
    comment: "Do not edit the translation submitted. Pre-approved text, must not deviate.",
  });

  const advantagesList = [
    i18n.t({
      id: "tradeOrgLayout.mobilitypool.section.one.advantages.itemOne",
      message: "Financing",
      comment: "Do not edit the translation submitted. Pre-approved text, must not deviate.",
    }),
    i18n.t({
      id: "tradeOrgLayout.mobilitypool.section.one.advantages.itemTwo",
      message: "Insurance",
      comment: "Do not edit the translation submitted. Pre-approved text, must not deviate.",
    }),
    i18n.t({
      id: "tradeOrgLayout.mobilitypool.section.one.advantages.itemThree",
      message: "Workshops",
      comment: "Do not edit the translation submitted. Pre-approved text, must not deviate.",
    }),
    i18n.t({
      id: "tradeOrgLayout.mobilitypool.section.one.advantages.itemFour",
      message: "Tires and rims",
      comment: "Do not edit the translation submitted. Pre-approved text, must not deviate.",
    }),
    i18n.t({
      id: "tradeOrgLayout.mobilitypool.section.one.advantages.itemFive",
      message: "Guarantees",
      comment: "Do not edit the translation submitted. Pre-approved text, must not deviate.",
    }),
    i18n.t({
      id: "tradeOrgLayout.mobilitypool.section.one.advantages.itemSix",
      message: "Parts and equipment",
      comment: "Do not edit the translation submitted. Pre-approved text, must not deviate.",
    }),
    i18n.t({
      id: "tradeOrgLayout.mobilitypool.section.one.advantages.itemSeven",
      message: "Car care",
      comment: "Do not edit the translation submitted. Pre-approved text, must not deviate.",
    }),
    i18n.t({
      id: "tradeOrgLayout.mobilitypool.section.one.advantages.itemEight",
      message: "Transportation",
      comment: "Do not edit the translation submitted. Pre-approved text, must not deviate.",
    }),
    i18n.t({
      id: "tradeOrgLayout.mobilitypool.section.one.advantages.itemNine",
      message: "Accounting",
      comment: "Do not edit the translation submitted. Pre-approved text, must not deviate.",
    }),
    i18n.t({
      id: "tradeOrgLayout.mobilitypool.section.one.advantages.itemTen",
      message: "Administration tools",
      comment: "Do not edit the translation submitted. Pre-approved text, must not deviate.",
    }),
  ];

  const listTitle = i18n.t({
    id: "tradeOrgLayout.mobilitypool.section.one.title",
    message:
      "This ensures the car dealer very good conditions for offering its customers leading services and products within:",
    comment: "Do not edit the translation submitted. Pre-approved text, must not deviate.",
  });

  return (
    <Layout
      left={
        <>
          <Title title={pageTitle} />
          <Text text={descriptionText} />
          <div className="mt-40">
            <List title={listTitle} listElements={advantagesList} />

            <div className="mt-40 pb-40 border-b md:border-none">
              <p className="mt-16 mb-0">
                <Trans
                  id="tradeOrgLayout.mobilitypool.section.two.text"
                  message="These tools enable the used car dealer to offer the same security in a car sale as a new car dealer."
                  comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
                />
              </p>
            </div>
          </div>
        </>
      }
      right={<OrgLinks pageName={pageName} />}
    />
  );
};

export default MobilityPool;
